export const CCancelButton = ({ data, onCancel, loading }) => {
    // return (
    //     <button
    //         disabled={loading}
    //         onClick={() => onCancel(data)}
    //     >
    //         {loading ? "Cancelling..." : "Cancel"}
    //     </button>
    // );
    return (
        <button
            type="button"
            className="btn btn-outline-danger btn-sm d-flex align-items-center gap-2"
            disabled={loading}
            onClick={() => onCancel(data)}
        >
            {loading ? (
                <>
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                    ></span>
                    Cancelling...
                </>
            ) : (
                <>
                    <i className="bi bi-x-circle"></i>
                    Cancel
                </>
            )}
        </button>
    );
};